export const roomFilterOptions = {
  BREAKFAST_INCLUDED: 'BREAKFAST_INCLUDED',
  PAY_AT_THE_HOTEL: 'PAY_AT_THE_HOTEL',
  BUY_NOW_PAY_LATER: 'BUY_NOW_PAY_LATER',
  FREE_CANCELLATION: 'FREE_CANCELLATION',
  HALF_BOARD: 'HALF_BOARD',
  FULL_BOARD: 'FULL_BOARD',
  SINGLE_BED: 'SINGLE_BED',
  TWIN_BED: 'TWIN_BED',
  ROOM_ONLY: 'ROOM_ONLY',
  PAY_NOW: 'PAY_NOW',
};

export const roomFilterCategories = ['meal', 'booking', 'bed'];
